$(document).ready(function () { 
  $(document).on('click', '[data-accordion-trigger]', function (e) {
    e.preventDefault();

    var Collapsible = $(this).closest('[data-accordion-section]');

    var parentCollapsible = $(this).closest('[data-accordion]');
    var collapsibleInner = parentCollapsible.find('[data-accordion-content]');

    if ($(this).attr('aria-expanded') === 'false') {
      Collapsible.find('[data-accordion-trigger]').attr('aria-expanded', 'false');
      Collapsible.find('[data-accordion-content]').slideUp();

      $(this).attr('aria-expanded', 'true');
      collapsibleInner.slideDown();

    } else {
      $(this).attr('aria-expanded', 'false');
      collapsibleInner.slideUp();
    }
  });

  $(document).on('click', '.js-toggle_tab', function (e) {
    e.preventDefault();

    let Tabs = $(this).closest('.Section_Tabs'),
        tab_id = $(this).attr('aria-controls');

    Tabs.find('.js-toggle_tab').removeClass('is_active');
    Tabs.find('.js-toggle_tab').attr('aria-selected', 'false');
    Tabs.find('.TabPanel').attr('aria-hidden', 'true');

    $(this).addClass('is_active');
    $(this).attr('aria-selected', 'true');
    $('#' + tab_id).attr('aria-hidden', 'false');
  });

  $(document).on('click', '.js-toggle_collapsible', function (e) {
    e.preventDefault();
    
    let Collapsible = $(this).closest('.Section_Collapsible'),
        parentCollapsible = $(this).closest('.Collapsible'),
        collapsibleInner = parentCollapsible.find('.Collapsible__Inner');

      if ($(this).attr('aria-expanded') === 'false') {
        Collapsible.find('.Collapsible').removeClass('is_active');
        Collapsible.find('.js-toggle_collapsible').attr('aria-expanded', 'false');
        Collapsible.find('.Collapsible__Inner').slideUp();

        parentCollapsible.addClass('is_active');
        $(this).attr('aria-expanded', 'true');
        collapsibleInner.slideDown();

      } else {
        parentCollapsible.removeClass('is_active');
        $(this).attr('aria-expanded', 'false');
        collapsibleInner.slideUp();
      }
  });

  $('.js-section_overflow').on('click', '.js_loadMore', function (e) {
    e.preventDefault();

    $(this).closest('.js-section_overflow').toggleClass('show');

    if ($(this).closest('.js-section_overflow').hasClass('show')) {
      $(this).find('span').html('Read less');
    } else {
      $(this).find('span').html('Read more');
    }
  });

  equals_height();
  position_heading_page('template_page_about');
  position_heading_page('template_page_contact');

  $(window).on('resize', function () {
    equals_height();
    position_heading_page('template_page_about');
    position_heading_page('template_page_contact');
  });
});

function equals_height() {
  setTimeout(function () {
    $('.equals-height').equalHeights();
  }, 300);

  setTimeout(function () {
    let elms = $('.flickity-slider').find('.equals-height-card-content');
    elms.equalHeights();
  }, 1000);
}


function position_heading_page(page) {
  let page_template = $('.'+page),
      first_section = page_template.find('.image-with-text').first(),
      first_heading = first_section.find('.image-with-text__heading').first(),
      first_content = first_section.find('.image-with-text__content');

  if ($(window).width() < 749) {
    first_section.prepend(first_heading);
  } else {
    first_content.prepend(first_heading);
  }
}